import { render, staticRenderFns } from "./DrillScoring.vue?vue&type=template&id=f6a3637e&scoped=true&lang=pug&"
import script from "./DrillScoring.vue?vue&type=script&lang=ts&"
export * from "./DrillScoring.vue?vue&type=script&lang=ts&"
import style0 from "./DrillScoring.vue?vue&type=style&index=0&id=f6a3637e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a3637e",
  null
  
)

export default component.exports